"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseCard = exports.CourseCardDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var card_1 = require("../../components/elements/card");
var entity_image_1 = require("../../components/entities/entity-image");
var content_1 = require("../../components/elements/content");
var entity_cell_header_1 = require("../../components/entities/entity-cell-header");
var entity_count_label_1 = require("../../components/entities/entity-count-label");
var icon_label_1 = require("../../components/elements/icon-label");
var ui_1 = require("@shapeable/ui");
var icons_1 = require("@shapeable/icons");
var sprintf_js_1 = require("sprintf-js");
var cls = (0, utils_1.classNames)('program-card');
exports.CourseCardDefaultProps = {};
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "], ["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(21), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('link-hover'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ButtonsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-top: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Image: (0, styled_components_1.default)(entity_image_1.EntityImage)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles),
  Buttons: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  DetailsButton: (0, styled_components_1.default)(ui_1.Button)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  RegisterButton: (0, styled_components_1.default)(ui_1.Button)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
var CourseCard = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var _a = entity.participants,
    participants = _a === void 0 ? [] : _a,
    description = entity.description,
    registrationUrl = entity.registrationUrl,
    startDate = entity.startDate,
    _b = entity.lessons,
    lessons = _b === void 0 ? [] : _b,
    program = entity.program,
    isCurrentUserParticipating = entity.isCurrentUserParticipating;
  var Icons = (0, use_icons_1.useIcons)();
  var t = (0, ui_1.useLang)();
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var onRegisterButtonClick = function (event) {
    if (!registrationUrl) return;
    event.preventDefault();
    event.stopPropagation();
    window.open(registrationUrl, '_blank');
  };
  return react_1.default.createElement(My.Card, __assign({}, props, {
    // hspace={hspace}
    space: 4,
    titleMargin: "none",
    to: definition.to(entity.slug),
    className: className,
    image: react_1.default.createElement(My.Image, {
      entity: entity
    })
  }), react_1.default.createElement(My.Header, {
    entity: entity
  }), react_1.default.createElement(My.Title, null, entity.name), !!program && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(icons_1.LayoutIcon, null)
  }, t("Program:"), " ", program === null || program === void 0 ? void 0 : program.name), !!startDate && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(Icons.BriefcaseCircle, null)
  }, t("Starting:"), " ", (0, utils_1.formatDateString)(startDate, 'DD MMM YYYY')), !!lessons.length && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(icons_1.KeyIssueIcon, null)
  }, (0, sprintf_js_1.sprintf)(lessons.length === 1 ? t("%s Module") : t("%s Modules"), lessons.length)), react_1.default.createElement(My.Buttons, null, react_1.default.createElement(My.DetailsButton, null, t('Enter Course')), !isCurrentUserParticipating && !!registrationUrl && react_1.default.createElement(My.RegisterButton, {
    onClick: onRegisterButtonClick
  }, t("Register"))), children);
};
exports.CourseCard = CourseCard;
exports.CourseCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;